import { Injectable } from '@angular/core';
import { LoginModalContent } from '../../models/aem';

@Injectable({
  providedIn: 'root'
})
export class LoginHelpScreenAdapterService {
  getLoginHelpScreenContent(loginModalContent: LoginModalContent) {
    const { loginHelp, pageHeader } = loginModalContent;
    const pageHeaderObj = {
      logoUrl: pageHeader.logoUrl,
      altText: pageHeader.altText
    };

    return {
      loginHelpScreenView: { ...loginHelp, ...pageHeaderObj }
    };
  }
}
